module.exports = __webpack_public_path__ + "img/maximum-for-good-logo.c5310207.png";